import React, { useState } from 'react';
import api from '../services/api';
import { Send, Users, User, Bell, ShieldCheck } from 'lucide-react';
import { PageHeader } from './ui/PageHeader';

const NotificationCenter: React.FC = () => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [sending, setSending] = useState(false);

    const handleSend = async (e: React.FormEvent) => {
        e.preventDefault();
        setSending(true);
        try {
            await api.post('/admin/notify', { title, body, target_all: true });
            alert('Push notification broadcasted');
            setTitle(''); setBody('');
        } catch (e) { alert('Broadcast failed'); }
        setSending(false);
    };

    return (
        <div className="space-y-6 max-w-2xl">
            <PageHeader title="Notification Center" subtitle="Send urgent push alerts to all residents" />

            <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
                <form onSubmit={handleSend} className="space-y-4">
                    <div className="space-y-1">
                        <label className="text-xs font-semibold text-slate-500">Alert Title</label>
                        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Urgent: Water Supply Cut" className="w-full bg-slate-50 border border-slate-200 rounded-lg p-2.5 text-sm outline-none focus:ring-2 focus:ring-violet-500" required />
                    </div>
                    <div className="space-y-1">
                        <label className="text-xs font-semibold text-slate-500">Message Body</label>
                        <textarea value={body} onChange={e => setBody(e.target.value)} rows={3} placeholder="Provide concise information for the push alert..." className="w-full bg-slate-50 border border-slate-200 rounded-lg p-2.5 text-sm outline-none focus:ring-2 focus:ring-violet-500" required />
                    </div>
                    <div className="p-4 bg-violet-50 rounded-lg flex gap-3">
                        <Bell className="text-violet-600 shrink-0" size={20} />
                        <p className="text-xs text-violet-700 leading-relaxed">
                            This will send an immediate push notification to all residents who have the Society Mitra app installed and have enabled notifications.
                        </p>
                    </div>
                    <div className="flex justify-end pt-2">
                        <button type="submit" disabled={sending} className="bg-violet-600 text-white px-8 py-2.5 rounded-lg font-bold text-sm hover:bg-violet-700 transition-all flex items-center gap-2 disabled:opacity-50">
                            {sending ? 'Sending...' : 'Broadcast Push Alert'}
                            <Send size={16} />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NotificationCenter;
